import { ChevronDown, ChevronRight } from 'react-feather';

const OrderSalesmanSection = ({
	sections,
	toggleSection,
	orderDetails,
}) => {
	return (
		<div className="tab-information">
			<div className="tab-information-block">
				<div className="title-block" onClick={() => toggleSection('sale')}>
					<h2 className="title-h2">Sales Representative</h2>
					<button>
						{sections.sale ? (
							<ChevronDown size={24} />
						) : (
							<ChevronRight size={24} />
						)}
					</button>
				</div>
				{sections.sale && (
					<div className="content-block">
						<div className="grid grid-flow-row-dense grid-cols-2 grid-rows-2 content-block">
							<p className="data-content">
								<strong>Full Name</strong>
								{orderDetails.salesman.fullName}
							</p>

							<p className="data-content">
								<strong>Email</strong>
								<a href={`mailto:${orderDetails.salesman.email}`}>
									{orderDetails.salesman.email}
								</a>
							</p>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default OrderSalesmanSection;
